import React = require('react');

interface IBenefitSection {
  imageSrc: string,
  title: string,
  text: any
}

export const WhatsCovered = () => {

  const benefitsSection1: IBenefitSection[] = [
    {
      imageSrc: require('./images/badge-medical-expenses.svg'),
      title: 'Emergency medical expenses',
      text: 'We cover reasonable and necessary emergency medical treatment costs if you get ill or injured in an accident abroad.'
    },
    {
      imageSrc: require('./images/badge-delayed-missed-departure.svg'),
      title: 'Delayed or missed departure',
      text: 'If you\'re delayed or miss your transport due to unforeseen circumstances, we\'ll cover reasonable costs for accommodation and travel.'
    },
    {
      imageSrc: require('./images/badge-lost-stolen-luggage.svg'),
      title: 'Lost or stolen personal belongings',
      text: 'You can claim up to your policy limits if your personal belongings or luggage are lost, stolen or accidentally damaged during your trip.'
    }
  ];

  const benefitsSection2: IBenefitSection[] = [
    {
      imageSrc: require('./images/badge-cancelled.svg'),
      title: 'Cancelling or cutting your trip short',
      text: 'We\'ll cover cost up to your policy limit for things like deposits or parking fees if you have to unexpectedly cancel or cut short your trip.'
    },
    {
      imageSrc: require('./images/badge-liability-legal-assistance.svg'),
      title: 'Personal liability and legal assistance',
      text: 'We\'ll support you with legal costs to help you claim damages or compensation for injury, illness or death during your trip.'
    },
    {
      imageSrc: require('./images/badge-travel-mask.svg'),
      title: 'Specific COVID-19 related events',
      text: <span>Read about how COVID-19 affects your travel insurance on our dedicated <a
        href={'https://www.admiral.com/travel-insurance/FAQs'} target={'_blank'}>FAQ page</a></span>
    }
  ];

  return (
    <div className={'whats-c-container'}>
      <div className={'w-c-title'}><h1>What's covered</h1></div>
      <div className={'w-c-sub-text'}>Here are some key features of our travel insurance. As with any insurance, policy
        limits and exclusions apply, so always read your policy book.
      </div>

      <div className={'benefits-container'}>

        {benefitsSection1.map((benefit: IBenefitSection, index) => {
          return (
            <div className={'benefits-section'} key={index}>
              <div className={'benefit-s-image'}><img src={benefit.imageSrc} alt={'ICON'}/></div>
              <div className={'benefit-s-title'}>{benefit.title}</div>
              <div className={'benefit-s-text'}>{benefit.text}</div>
            </div>
          )
        })}
      </div>

      <div className={'benefits-container'}>
        {benefitsSection2.map((benefit: IBenefitSection, index) => {
          return (
            <div className={'benefits-section'} key={index}>
              <div className={'benefit-s-image'}><img src={benefit.imageSrc} alt={'ICON'}/></div>
              <div className={'benefit-s-title'}>{benefit.title}</div>
              <div className={'benefit-s-text'}>{benefit.text}</div>
            </div>
          )
        })}

      </div>
    </div>
  )
}
